// const adres = 'http://localhost:3000'
const adres = 'https://formsapi.ankaradil.com'
import axios from 'axios'
function post (adr, header, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(adres + adr, params, header)
      .then((response) => {
        if (response.data.errCode && response.data.errCode === -1) {
          alert('Hata!!')
        }
        resolve(response.data)
      }).catch(
        e => reject(e.message)
      )
  })
}
// function get (adr, header, params) {
//   return new Promise((resolve, reject) => {
//     axios
//       .get(adres + adr, params, header)
//       .then((response) => {
//         if (response.data.errCode && response.data.errCode === -1) {
//           const st = store()
//           alert('Kullanıcı Hatası Lütfen Yeniden Giriş Yapın')
//           st.dispatch('anket/logoutAction')
//         }
//         resolve(response.data)
//       }).catch(
//         e => reject(e.message)
//       )
//   })
// }
// function get(adr, header, params) {
//
// }
export async function tryLogin (uname, passw) {
  const params = {
  }
  const auth = {
    auth: {
      username: uname,
      password: passw
    }
  }
  return await post('/users/login', auth, params)
}
export async function sendAnket (token, id, ad, baslangictarihi, bitistarihi, yayinlandi) {
  const params = {
    id: id,
    ad: ad,
    yayinlanmatarihi: baslangictarihi,
    bitistarihi: bitistarihi,
    yayinlandi: yayinlandi
  }
  const auth = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return await post('/anket/addupdate', auth, params)
}

export async function getAllAnkets (token) {
  const params = {
  }
  const auth = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return await post('/anket/getAll', auth, params)
}
export async function getOneAnket (token, id) {
  const params = {
    id: id
  }
  const auth = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return await post('/anket/getOne', auth, params)
}
export async function getOneAnketResult (id) {
  const params = {
    id: id
  }

  const auth = {
  }

  return await post('/anket/getOneAnketResultsV3', auth, params)
}

export async function getOneURLAnket (kisaurl, kidi ) {
  const params = {
    kisaurl: kisaurl,
    kisiid: kidi
  }
  // const auth = {
  //   headers: { Authorization: `Bearer ${token}` }
  // }
  return await post('/anket/getOneWURL', {}, params)
}

export async function saveAnketJSON (token, id, json) {
  const params = {
    id: id,
    anketjson: json
  }
  const auth = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return await post('/anket/saveAnketJSON', auth, params)
}

export async function checkIsAdmin (token) {
  const params = {
  }
  const auth = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return await post('/users/isAdmin', auth, params)
}

export async function deleteAnket (token, id) {
  const params = {
    id: id
  }
  const auth = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return await post('/anket/delete', auth, params)
}

export async function saveAnketResultJSON (kisaurl, json) {
  const params = {
    kisaurl: kisaurl,
    anketresult: json
  }
  const auth = {
  }
  return await post('/anket/saveAnketResults', auth, params)
}

export async function saveAnketResultWKisiJSON (kisaurl, kisiid,  json) {
  const params = {
    kisaurl: kisaurl,
    kisiid: kisiid,
    anketresult: json
  }
  const auth = {
  }
  return await post('/anket/saveAnketResults', auth, params)
}
